import React from 'react';

export const Segment = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      id="segmentation"
      xmlns="http://www.w3.org/2000/svg"
      width="23.907"
      height="23.907"
      viewBox="0 0 23.907 23.907"
    >
      <path
        id="Path_63883"
        data-name="Path 63883"
        d="M332.465,53.175a12.065,12.065,0,0,0-3.445-4.123.7.7,0,0,0-1.03.208l-2.873,4.976a.7.7,0,0,0,.116.85,4.887,4.887,0,0,1,0,6.988.7.7,0,0,0-.116.85L327.99,67.9a.7.7,0,0,0,1.03.208,12.065,12.065,0,0,0,3.445-4.123,11.973,11.973,0,0,0,0-10.808Z"
        transform="translate(-309.847 -46.626)"
        fill={primaryFontColor}
      />
      <g id="Group_41523" data-name="Group 41523" transform="translate(0)">
        <path
          id="Path_63884"
          data-name="Path 63884"
          d="M63.223.936a11.981,11.981,0,0,0-10.048.353,12.065,12.065,0,0,0-4.123,3.445.7.7,0,0,0,.208,1.03l4.976,2.873a.7.7,0,0,0,.85-.116,4.856,4.856,0,0,1,4.8-1.287.7.7,0,0,0,.794-.325l2.874-4.978a.7.7,0,0,0-.334-1Z"
          transform="translate(-46.626)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63885"
          data-name="Path 63885"
          d="M157.433,361.849l-2.874-4.978a.7.7,0,0,0-.794-.325,4.762,4.762,0,0,1-2.618,0,.7.7,0,0,0-.794.325l-2.874,4.978a.7.7,0,0,0,.334,1,11.989,11.989,0,0,0,9.287,0A.7.7,0,0,0,157.433,361.849Z"
          transform="translate(-140.502 -339.873)"
          fill={primaryFontColor}
        />
        <path
          id="Path_63886"
          data-name="Path 63886"
          d="M8.521,155.948a4.855,4.855,0,0,1-1.287-4.8.7.7,0,0,0-.325-.794l-4.978-2.874a.7.7,0,0,0-1,.334h0a11.98,11.98,0,0,0,.353,10.048,12.065,12.065,0,0,0,3.445,4.123h0a.7.7,0,0,0,1.03-.208L8.637,156.8A.7.7,0,0,0,8.521,155.948Z"
          transform="translate(0 -140.501)"
          fill={primaryFontColor}
        />
      </g>
    </svg>
  );
};
